import { render, staticRenderFns } from "./indexDetailUpload.vue?vue&type=template&id=7d0c51de&scoped=true&"
import script from "./indexDetailUpload.vue?vue&type=script&lang=js&"
export * from "./indexDetailUpload.vue?vue&type=script&lang=js&"
import style0 from "./indexDetailUpload.vue?vue&type=style&index=0&id=7d0c51de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c51de",
  null
  
)

export default component.exports